// extracted by mini-css-extract-plugin
module.exports = {"contact-form":"ContactForm_contact-form__1Io_c"};